var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWholesaleOrder1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #e0ef4d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.55,
    y: 28.73,
    width: 171.83,
    height: 210.25,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 77.27,
    y1: 210.19,
    x2: 155.67,
    y2: 210.19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.07,142.53s6.54-2.62,13.25-1.43c6.71,1.18,10.21,4.3,10.21,4.3l-17.17,7.05-6.29-9.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.96,156.89v13.24c0,1.28,1.04,2.32,2.32,2.32h79.2s12.16,.55,37.75-5.7c9.86-2.41,18.41-6.32,20.84-9.44,0,0,1.18-9.02-6.86-13.39l-14.91,4.11-50.3,3.73-54.43,3.11-11.23-.3c-1.31-.03-2.39,1.02-2.39,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.39,98.07s-4.88-7.32-7.53-7.3-6.43,5.78-7.58,9.55l15.11-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.06,99.63c-1.19-.07-2.08,1.09-1.69,2.22,.77,2.2,1.79,5.45,2.01,7.73,.36,3.77,.58,9.27-1.74,15.14-2.32,5.87-6.45,24.41-4.78,29.84,0,0,72.08,.53,78.55,.21,6.47-.32,32.37-3.82,37.88-6.73,0,0-2.33-6.02-16.77-9.26-14.44-3.24-21.89-4.81-29.91-12.27-7.62-7.08-18.06-19.33-22.66-28.89-.42-.86-1.37-1.32-2.31-1.13-5.15,1.08-21.72,4.18-38.58,3.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 77.08,
    cy: 122.18,
    r: 12.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.8,126.12l-2.17,.77c-.55,.2-1.13-.22-1.12-.81l.06-2.3c0-.19-.06-.38-.17-.53l-1.4-1.82c-.36-.47-.14-1.15,.43-1.31l2.21-.65c.18-.05,.34-.17,.45-.33l1.3-1.9c.33-.48,1.05-.48,1.38,0l1.3,1.9c.11,.16,.27,.28,.45,.33l2.21,.65c.56,.17,.79,.85,.43,1.31l-1.4,1.82c-.12,.15-.18,.34-.17,.53l.06,2.3c.02,.59-.56,1.01-1.12,.81l-2.17-.77c-.18-.06-.38-.06-.56,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 93.73,
    y1: 107.25,
    x2: 102.69,
    y2: 103.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.73,109.04c-.68,0-1.33-.39-1.63-1.05-.4-.9,0-1.95,.89-2.36l8.96-4.03c.9-.41,1.95,0,2.36,.89,.4,.9,0,1.95-.89,2.36l-8.96,4.03c-.24,.11-.49,.16-.73,.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 105.46,
    y1: 123.35,
    x2: 113.39,
    y2: 117.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.46,125.13c-.55,0-1.09-.25-1.44-.73-.58-.79-.41-1.91,.39-2.49l7.93-5.81c.79-.58,1.91-.41,2.49,.38,.58,.79,.41,1.91-.39,2.49l-7.93,5.81c-.32,.23-.69,.34-1.05,.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 140.58,
    y1: 144.67,
    x2: 145.85,
    y2: 136.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.58,146.45c-.33,0-.66-.09-.95-.28-.83-.53-1.08-1.63-.55-2.46l5.27-8.3c.53-.83,1.63-1.07,2.46-.55,.83,.53,1.08,1.63,.55,2.46l-5.27,8.3c-.34,.53-.92,.83-1.51,.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 120.02,
    y1: 136.34,
    x2: 126.97,
    y2: 129.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.02,138.12c-.46,0-.91-.17-1.26-.52-.7-.7-.7-1.82,0-2.52l6.95-6.95c.7-.7,1.83-.7,2.52,0,.7,.7,.7,1.82,0,2.52l-6.95,6.95c-.35,.35-.8,.52-1.26,.52Z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 97.61,
    y: 61.02,
    width: 171.83,
    height: 210.25,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.06,111.34c-1.35-4.79-5.06-8.55-9.83-9.97l-18.43-5.5c-.22,1.15-.7,2.26-1.46,3.22l-.73,.93-.89,1.13-5.66,7.21c-1.45,1.85-3.91,2.58-6.13,1.83l-6.19-2.08v19.16c0,1.07-.86,1.93-1.93,1.93h-6.51c-1.07,0-1.93-.86-1.93-1.93v-19.16l3.7-1.24h0l-9.9,3.32c-2.23,.75-4.68,.01-6.13-1.83l-7.28-9.27c-.76-.97-1.25-2.08-1.46-3.23l-18.45,5.51c-4.77,1.42-8.48,5.18-9.83,9.97l-9.28,32.78,17.3,5.8,.7,.24h0l3.51,1.18v9.06h0v50.5h84.6v-59.56l11.69-3.92h0l1.07-.36,8.75-2.93-9.28-32.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "182.06 106.88 182.06 106.88 183.54 106.38 182.06 106.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.93,90.16h-33.79l.07,.14c.36,.67,.82,1.28,1.4,1.8l15.93,14.28h0l11.05-9.9,.5-.45,4.38-3.92c.47-.42,.87-.91,1.2-1.44l.27-.5h-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 216.01,
    y: 210.89,
    width: 1.4,
    height: 0
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.41,210.89h-76.18v3.2c0,3.18,2.58,5.77,5.77,5.77h73.06c3.18,0,5.77-2.58,5.77-5.77v-3.2h-8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.72,150.16l-.7-.24h0l-17.3-5.8-.57,2.01c-.99,3.51,.94,7.18,4.4,8.34l13.46,4.51,4.21,1.41h0v-9.06l-3.51-1.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 237.52,
    y: 147.42,
    width: 0,
    height: 0,
    transform: "translate(-40.85 121.78) rotate(-26.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 237.49,
    y: 147.24,
    width: 1.13,
    height: 0,
    transform: "translate(-24.25 49.54) rotate(-11.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.9,146.13l-.57-2.01-8.75,2.93h0l-1.07,.36h0l-11.69,3.92v9.06l11.22-3.76h0l6.45-2.16c3.46-1.16,5.4-4.83,4.4-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.33,80.47h-27.59c-1.54,0-3.02,.42-4.3,1.19v5.59c0,1.02,.25,2.01,.69,2.9h34.79c.45-.89,.69-1.89,.69-2.91v-5.59h0c-1.28-.77-2.76-1.19-4.3-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.61,92.1c-.58-.52-1.04-1.13-1.4-1.8h0s-.05-.09-.07-.14c-.45-.89-.69-1.88-.69-2.9h0v-5.59c-.97,.58-1.82,1.36-2.5,2.31l-2.27,3.18-2.14,3c-1.21,1.69-1.62,3.76-1.26,5.71,.22,1.15,.7,2.26,1.46,3.23l7.28,9.27c1.45,1.85,3.91,2.58,6.13,1.83l9.9-3.32,1.48-.5-15.93-14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.02,106.88l-1.48-.5h0l-1.48,.5-3.7,1.24v19.16c0,1.07,.86,1.93,1.93,1.93h6.51c1.07,0,1.93-.86,1.93-1.93v-19.16l-3.7-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.54,90.15l-2.14-3-2.27-3.18c-.67-.95-1.53-1.72-2.5-2.31h0v5.59c0,1.02-.25,2.01-.69,2.91l-.27,.5c-.33,.53-.72,1.02-1.2,1.44l-4.38,3.92-.5,.45-11.05,9.9,1.48,.5h0l3.7,1.24,6.19,2.08c2.23,.75,4.68,.01,6.13-1.83l5.66-7.21,.89-1.13,.73-.93c.76-.97,1.25-2.07,1.46-3.22,.37-1.95-.05-4.02-1.26-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 184.28,
    y: 105.85,
    width: 0,
    height: 1.56,
    transform: "translate(24.58 247.42) rotate(-71.45)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 144.33,
    y1: 242.47,
    x2: 222.73,
    y2: 242.47
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholesaleOrder1);
export default __webpack_public_path__ + "static/media/wholesale_order_1.aaa8bdd9a664312fc94350ade306425a.svg";
export { ForwardRef as ReactComponent };